/* Page-owned data-hygiene shim - collection-asscher-cut-2026 only.
   The live store misspells the cut "Ascher" in the collection title and in 7 of the
   8 product titles (e.g. "0.25-2.00 CT Ascher Cut Natural Diamonds - Stud Earrings").
   collection.js derives every card name, quick-view title, compare row and cart-tray
   line from the title string, so without this fix the whole grid renders the typo.
   Load order is guaranteed by the template: assets/data/products.js loads in <head>
   (synchronous), this file loads immediately after via head.extraScripts, and the
   shell (collection.js) is deferred - so the shell only ever sees "Asscher".
   DISPLAY STRINGS ONLY: handles, URLs, ids and prices are untouched, so links still
   resolve to the live "ascher" handles. A data re-pull rewrites products.js but not
   this file, so the correction survives refreshes.
   The real fix is correcting the titles in Shopify - flagged in the build report. */
(function () {
  var C = window.PS_COLLECTION;
  if (!C) return;
  function fix(s) { return typeof s === 'string' ? s.replace(/\bAscher\b/g, 'Asscher') : s; }
  if (C.collection) C.collection.title = fix(C.collection.title);
  (C.products || []).forEach(function (p) { p.title = fix(p.title); });
})();
